import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { LoginComponent } from './modules/usuario/pages/authentication/login/login.component';
import { AcessoNegadoComponent } from './shared/components/acesso-negado/acesso-negado.component';
import { CriarSenhaLoginComponent } from './modules/usuario/authentication/criar-senha-login/criar-senha-login.component';

const routes: Routes = [
  {
    path: 'acesso-negado',
    component: AcessoNegadoComponent
  },
  {
    path: 'autenticacao/login',
    component: LoginComponent
  },
  {
    path: 'autenticacao/esqueci-minha-senha',
    component: LoginComponent
  },  
  {
    path: 'autenticacao/criar-senha-usuario/:token',
    component: CriarSenhaLoginComponent
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },  
  {
    path: '',
    component: LayoutComponent,
    children: [
        {
            path: 'dashboard',
            loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
        },        
        {
            path: 'produto',
            loadChildren: () => import('./modules/produto/produto.module').then(m => m.ProdutoModule)
        },
        {
          path: 'usuario',
          loadChildren: () => import('./modules/usuario/usuario.module').then(m => m.UsuarioModule)
        },
        {
          path: 'categoria',
          loadChildren: () => import('./modules/categoria/categoria.module').then(m => m.CategoriaModule)
        },
        {
          path: 'produto-unidade-medida',
          loadChildren: () => import('./modules/produto-unidade-medida/produto-unidade-medida.module').then(m => m.ProdutoUnidadeMedidaModule)
        },
        {
          path: 'produto-tipo',
          loadChildren: () => import('./modules/produto-tipo/produto-tipo.module').then(m => m.ProdutoTipoModule)
        },
        {
          path: 'pedido',
          loadChildren: () => import('./modules/pedido/pedido.module').then(m => m.PedidoModule)
        },
        {
          path: 'armazenagem',          
          loadChildren: () => import('./modules/armazenagem/armazenagem.module').then(m => m.ArmazenagemModule)
        },
        {
          path: 'recebimento',
          loadChildren: () => import('./modules/recebimento/recebimento.module').then(m => m.RecebimentoModule)
        },
        {
          path: 'cliente',
          loadChildren: () => import('./modules/cliente/cliente.module').then(m => m.ClienteModule)
        },
        {
          path: 'fornecedor',
          loadChildren: () => import('./modules/fornecedor/fornecedor.module').then(m => m.FornecedorModule)
        },
        {
          path: 'gestao-ativos',
          loadChildren: () => import('./modules/gestao-ativos/gestao-ativos.module').then(m => m.GestaoAtivosModule)
        },
        {
          path: 'condicao-pagamento',
          loadChildren: () => import('./modules/condicao-pagamento/condicao-pagamento.module').then(m => m.CondicaoPagamentoModule)
        },
        {
          path: 'recebimento-status',
          loadChildren: () => import('./modules/recebimento-status/recebimento-status.module').then(m => m.RecebimentoStatusModule)
        },
        {
          path: 'estoque',
          loadChildren: () => import('./modules/estoque/estoque.module').then(m => m.EstoqueModule)
        },
        {
          path: 'categoria-servico',
          loadChildren: () => import('./modules/categoria-servico/categoria-servico.module').then(m => m.CategoriaServicoModule)
        },
        {
          path: 'servico',
          loadChildren: () => import('./modules/servico/servico.module').then(m => m.ServicoModule)
        },
        {
          path: 'setor',
          loadChildren: () => import('./modules/setor/setor.module').then(m => m.SetorModule)
        },
        {
          path: 'tarefa-pedido',
          loadChildren: () => import('./modules/tarefa-pedido/tarefa-pedido.module').then(m => m.TarefaPedidoModule)
        },
        {
          path: 'chamado',
          loadChildren: () => import('./modules/chamado/chamado.module').then(m => m.ChamadoModule)
        },
        {
          path: 'departamento',
          loadChildren: () => import('./modules/departamento/departamento.module').then(m => m.DepartamentoModule)
        },
        {
          path: 'acesso',
          loadChildren: () => import('./modules/acesso/acesso.module').then(m => m.AcessoModule)
        },
        {
          path: 'calendario-servico',
          loadChildren: () => import('./modules/calendario-servico/calendario-servico.module').then(m => m.CalendarioServicoModule)
        },
        {
          path: 'manutencao',
          loadChildren: () => import('./modules/manutencao/manutencao.module').then(m => m.ManutencaoModule)
        },
        {
          path: 'sgi',
          loadChildren: () => import('./modules/sgi-informacao-documentada/sgi-informacao-documentada.module').then(m => m.SgiInformacaoDocumentadaModule)
        },
        {
          path: 'checklist',
          loadChildren: () => import('./modules/checklist/checklist.module').then(m => m.ChecklistModule)
        },
        {
          path: 'pre-pedido',
          loadChildren: () => import('./modules/pre-pedido/pre-pedido.module').then(m => m.PrePedidoModule)
        },
        {
          path: 'envio-relatorio',
          loadChildren: () => import('./modules/envio-relatorio/envio-relatorio.module').then(m => m.EnvioRelatorioModule)
        },
        {
          path: 'pendencias',
          loadChildren: () => import('./modules/pendencias/pendencias.module').then(m => m.PendenciasModule)
        },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }